/**
 * Performs a full-page navigation. Thin wrapper around `window.location.assign`
 * so non-React callers (e.g. API interceptors) have a single, mockable seam for
 * hard redirects.
 */
export function redirectTo(url: string): void {
  window.location.assign(url);
}
